var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fm-table-new',{attrs:{"size":"small","auto-height":"","stripe":false,"full":"","columns":_vm.columns,"data-list":_vm.dataList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }